import request from "@/utils/request.js"
// 登录
export const Login = (data)=>{
    return request({
        url:'/login',
        method:'post',
        data
    })
}
// 验证码 
export const getCaptcha =(params)=>{
    return request({
        url:'/captchaImage',
        method:'get',
        params
    })
}
//查询用户信息 
export const getUserInfo =(params)=>{
    return request({
        url:'/getInfo',
        method:'get',
        params
    })
}
